
import { Base } from '../base-component';
import './share.component.scss';

export class Share extends Base {

	shareButton: Element;
	shareLinks: Element[];

	emailButton: Element;
	facebookButton: Element;
	twitterButton: Element;
	linkedinButton: Element;
	whatsappButton: Element;

	shareUrl: string;
	shareTitle: string;
	shareDescription: string;
	shareImage: string;

	emailLink: string;
	facebookLink: string;
	twitterLink: string;
	linkedinLink: string;
	whatsappLink: string;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.shareButton = this.element.querySelector('.js-share');
		this.shareLinks = Array.from(this.element.querySelectorAll('.share__link'));

		this.emailButton = this.element.querySelector('.share__link--email');
		this.facebookButton = this.element.querySelector('.share__link--facebook');
		this.twitterButton = this.element.querySelector('.share__link--twitter');
		this.linkedinButton = this.element.querySelector('.share__link--linkedin');
		this.whatsappButton = this.element.querySelector('.share__link--whatsapp');

		this.shareUrl = encodeURIComponent(document.URL);
		this.shareTitle = '';
		this.shareDescription = '';
		this.shareImage = '';

		this.setShareLinks();


	}

	bindEvents() {

		document.addEventListener('click', () => this.closeShareOnDocumentClick(event));
		this.shareButton.addEventListener('click', () => this.toggleShare());

		if(this.facebookButton) {
			this.facebookButton.addEventListener('click', (event)=>{
	
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.twitterButton) {
			this.twitterButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.linkedinButton) {
			this.linkedinButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}
		if(this.whatsappButton) {
			this.whatsappButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		window.addEventListener('resize', (event)=>{

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsappButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsappButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}

		})

	}

	getShareMeta(meta) {

		let ogAttribute = document.querySelector(`meta[property='og:${meta}']`);

		if (ogAttribute) {
			return encodeURIComponent(ogAttribute.getAttribute('content'));
		}

		return '';

	}

	setShareMeta() {
		this.shareTitle = this.getShareMeta('title');
		this.shareDescription = this.getShareMeta('description');
		this.shareImage = this.getShareMeta('image');
	}

	setShareLinks() {

		this.setShareMeta();

		setTimeout(() => {

			this.emailButton.setAttribute(
				'href',
				`mailto:?subject=${this.shareTitle}&body=${this.shareDescription} - ${this.shareUrl}`
			);

			this.facebookButton.setAttribute(
				'data-social',
				`https://www.facebook.com/dialog/share?app_id=363419304366429&display=popup&href=${this.shareUrl}&redirect_uri=${this.shareUrl}`
			);

			this.twitterButton.setAttribute(
				'data-social',
				`https://twitter.com/intent/tweet?url=${this.shareUrl}&text=${this.shareDescription}`
			);

			this.linkedinButton.setAttribute(
				'data-social',
				`https://www.linkedin.com/shareArticle?mini=true&url=${this.shareUrl}`
			);
			
			

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsappButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsappButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}
			
		}, 200);

	}

	toggleShare() {

		if (this.emailButton.classList.contains('share__link--open')) {

			this.closeShare();

		} else {

			this.openShare();

		}

	}

	toggleIcons(action) {

		let shareIconClosed = this.element.querySelector('.js-share-closed');
		let shareIconOpened = this.element.querySelector('.js-share-opened');

		if (action === 'open') {

			shareIconClosed.classList.add('share__button-icon--hidden');
			shareIconOpened.classList.remove('share__button-icon--hidden');

		} else {

			shareIconOpened.classList.add('share__button-icon--hidden');
			shareIconClosed.classList.remove('share__button-icon--hidden');

		}

	}

	closeShareOnDocumentClick(event) {

		let targetElement = event.target;

		do {

			if (targetElement === this.element) {
				return;
			}

			targetElement = targetElement.parentNode;

		} while (targetElement);

		this.closeShare();

	}

	openShare() {

		this.toggleIcons('open');

		let timeoutDelay = 0;

		this.shareLinks.forEach(function (shareLink) {

			setTimeout(() => {
				shareLink.classList.add('share__link--open');
			}, timeoutDelay);

			timeoutDelay += 50;

		});

	}

	closeShare() {

		this.toggleIcons('close');

		let timeoutDelay = 0;
		let shareLinksClone = this.shareLinks.slice().reverse();

		shareLinksClone.forEach(function (shareLink) {

			setTimeout(() => {
				shareLink.classList.remove('share__link--open');
			}, timeoutDelay);

			timeoutDelay += 100;

		});

	}

	newPopup(url, windowName) {

		window.open(url,windowName,'height=500,width=500,left=10,top=10,titlebar=no,toolbar=no,menubar=no,location=no,directories=no,status=no');

	}

}



// WEBPACK FOOTER //
// ./components/share/share.component.ts